import React from 'react';
function IdealWeight({ result }) {
    return (
        <table >
            <thead>
                <tr>
                    <th >Formula/Equation</th>
                    <th >Ideal Weight</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Hamwi (1964)</td>
                    <td>{result.hamwi} kg</td>
                </tr>
                <tr>
                    <td>Devine (1974)</td>
                    <td>{result.devine} kg</td>
                </tr>
                <tr>
                    <td>Robinson (1983)</td>
                    <td>{result.robinson} kg</td>
                </tr>
                <tr>
                    <td>Miller (1983)</td>
                    <td>{result.miller} kg</td>
                </tr>
                <tr>
                    <td>Healthy Body Mass Index (BMI) Range</td>
                    <td>{result.bmiRange.lower} - {result.bmiRange.upper} kg</td>
                </tr>
            </tbody>
        </table>
    );
}
export default IdealWeight;
